module.exports = __webpack_public_path__ + "img/w48b.e771e03a.jpg";